var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CollapseCard',{attrs:{"is-green":true}},[_c('h3',{attrs:{"slot":"title-text"},slot:"title-text"},[_vm._v("Era uppgifter granskas")]),_c('template',{slot:"body-text"},[_c('p',[_vm._v(" Just nu granskar hyresvärdarna era uppgifter. Det innebär att det inte går att göra fler ändringar. ")])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }